import Vue from 'vue'
import Echo from 'laravel-echo'

window.io = require('socket.io-client')

export default (token) => {
  let host

  if (document.URL.indexOf('localhost') > 0) {
    host = 'http://localhost:6001'
  } else {
    host = 'https://www.tasin.com.tr'
  }

  Vue.prototype.$echo = new Echo({
    broadcaster: 'socket.io',
    host,
    auth: {
      headers: {
        Authorization:  'Bearer ' + token
      }
    }
  })
}
